module.exports = __webpack_public_path__ + "static/slider-img-3-ee6139558154c32088303ef69307c573.jpg";